import React from 'react';

import { HStack, Icon, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

interface StoreCardErrorProps {
  message: string;
}

export const StoreCardError: React.FC<StoreCardErrorProps> = ({ message }) => {
  return (
    <HStack alignItems="center" marginTop="$1.5">
      <Icon size="xs" marginRight="$1" color={primitive.$blackOpacity50} variant="info" />
      <Text variant="copyTwo" color={primitive.$blackOpacity50}>
        {message}
      </Text>
    </HStack>
  );
};
